import React, { useEffect, useState } from "react"
import { defineMessages, FormattedMessage, injectIntl } from "react-intl"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend/index"
import GlobalHelper from "../../common/GlobalHelper.jsx"
import ActionButton from "../../common/button/actionbutton.component.jsx"
import StateSelect from "../../common/contact/stateselector.component.jsx"
import CountrySelect from "../../common/contact/countryselector.component.jsx"
import ImageUploaderDropZone from "../../common/image-uploader/dropzone.component.jsx"
import ColorPicker from "../../common/color/picker.component.jsx"
import ProposalColorPreview from "../../settings/proposals/colorPreview.component.jsx"
import Icon from "../../common/icon/icon.component.jsx"
import { ONBOARDING_STEP } from "../Steps"
import Checkbox from "../../common/checkbox/checkbox.component.jsx"
import { Intl } from "../../state/helpers/IntlProps"
import { ContactDto } from "../../state/contact/models/contact"
import { createBrowserHistory } from "history"

const provinces = require("provinces")
const history = createBrowserHistory()

const messages = defineMessages({
    "choose_industry": {
        id: "welcome.sample.choose_industry",
        defaultMessage: "Choose",
    },
    "project_name": {
        id: "welcome.sample.project_name",
        defaultMessage: "Sample project",
    },
    "product_name": {
        id: "welcome.sample.product_name",
        defaultMessage: "Sample service",
    },
    "product_description": {
        id: "welcome.sample.product_description",
        defaultMessage: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam " +
            "nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.",
    },
    "quote_and_invoice_look_and_feel": {
        id: "welcome.quote_and_invoice_look_and_feel",
        defaultMessage: "Proposals and invoices look and feel",
    },
    "sample_quote_subject": {
        id: "welcome.sample_quote_subject",
        defaultMessage: "Look at your sample proposal",
    },
    "sample_quote_content": {
        id: "welcome.sample_quote_content",
        defaultMessage: "<p>Hi {firstName}</p><p>We created a sample proposal for you. This is how your customer would " +
            "receive your proposals. You can accept it online and you will receive a notification.</p>",
    },
    "sample_quote_button": {
        id: "welcome.sample_quote_button",
        defaultMessage: "Open proposal",
    },
    "sample_contact_name_1": {
        id: "welcome.sample_contact_name_1",
        defaultMessage: "John Smith",
    },
    "sample_contact_name_2": {
        id: "welcome.sample_contact_name_2",
        defaultMessage: "Jane Doe",
    },
    "sample_contact_name_3": {
        id: "welcome.sample_contact_name_3",
        defaultMessage: "Kelly White",
    }
})

type OwnProps = {
    intl: Intl,
    onStepCompleted: (payload) => object,
    step,
}

const InitialSetup = (props: OwnProps) => {

    const [state, setState] = useState({
        contact: null,
        contactImport: null,
        productImport: null,
        quote: null,
        quoteId: "",
        proposal: null,
        modal: null,
        redirect: null,
        companyName: "",
        currency: AppContext.getAccount().attributes.currency,
        organization: {},
        companyDescriptionId: "",
        templates: [],
        industries: [],
        industry: AppContext.getAccount().attributes.industryKey || "default",
        products: [],
        contacts: [],
        steps: [],
        isTaxInclusive: AppContext.getAccount().attributes.isTaxInclusive || false
    })

    const [countryCode, setCountryCode] = useState<string>("")
    const [stateCode, setStateCode] = useState<string>("")
    const [primaryColor, setPrimaryColor] = useState<string>("#05166B")
    const [buttonColor, setButtonColor] = useState<string>("#E6530A")
    const [backgroundColor, setBackgroundColor] = useState<string>("#f4f4f4")
    const [font] = useState<string>("Varela Round")
    const [images, setImages] = useState([])
    const [logo, setLogo] = useState(null)
    const [logoId, setLogoId] = useState<string>("")

    const [isLoading, setLoading] = useState<boolean>(false)

    const updateMarketingTracking = () => {
        const referer = AppContext.getCookie("qm_mkt_referer")
        const query = AppContext.getCookie("qm_mkt_url_query")
        if (referer) {
            AppContext.getApiClient().patch("/accounts/account-details", {
                referer: referer
            })
            AppContext.setCookie("qm_mkt_referer", "")
        }
        if (query) {
            history.push(location.pathname + "?" + query)
            AppContext.setCookie("qm_mkt_url_query", "")
        }
    }

    const loadCompanyDescription = () => {
        const promises: ContactDto[] = [] //todo: fix this
        promises.push(AppContext.getApiClient().get("/accounts/company-descriptions"))
        promises.push(AppContext.getApiClient().get("/industries"))

        Promise.all(promises).then(responses => {
            setState({
                ...state,
                companyName: responses[0].attributes.organization.attributes.name,
                organization: responses[0].attributes.organization,
                companyDescriptionId: responses[0].id,
                // @ts-ignore todo fix
                industries: responses[1].data || [],
            })

            setStateCode(responses[0].attributes.organization.attributes.address.stateCode)
            setCountryCode(responses[0].attributes.organization.attributes.address.countryCode)
        })
    }

    const submit = (props: OwnProps) => {
        setLoading(true)

        const name1 = props.intl.formatMessage(messages["sample_contact_name_1"]).split(" ")
        const name2 = props.intl.formatMessage(messages["sample_contact_name_2"]).split(" ")
        const name3 = props.intl.formatMessage(messages["sample_contact_name_3"]).split(" ")

        const country = getCountry()
        const province = getState()

        const payload = {
            companyName: state.companyName,
            industryKey: state.industry,
            currency: state.currency,
            isTaxInclusive: state.isTaxInclusive,
            state: province.name,
            stateCode: province.code,
            country: country.name,
            countryCode: country.code,
            companyLogoId: logoId,
            primaryColor: primaryColor,
            buttonColor: buttonColor,
            backgroundColor: backgroundColor,
            font: font,
            contacts: [
                { firstName: name1[0], lastName: name1[1], email: name1[0].toLowerCase() + "@quotemachine.com" },
                { firstName: name2[0], lastName: name2[1], email: name2[0].toLowerCase() + "@quotemachine.com" },
                { firstName: name3[0], lastName: name3[1], email: name3[0].toLowerCase() + "@quotemachine.com" },
            ],
        }

        props.onStepCompleted(payload)
    }


    useEffect(() => {
        loadCompanyDescription()
        updateMarketingTracking()
    }, [])

    useEffect(() => {
        if ([ONBOARDING_STEP.INITIAL_STEP].includes(props.step)) {
            return
        }
        // @ts-ignore todo fix
        if (state.steps.includes(props.step)) {
            return
        }

        setState({
            ...state,
            // @ts-ignore todo fix
            steps: state.steps.concat([props.step])
        })

        submit(props)
    }, [props.step])

    const handleFormChange = (event) => {
        const target = event.target
        const value = target.type === "checkbox" ? target.checked : target.value
        const name = target.name

        setState({
            ...state,
            [name]: value
        })
    }

    const getOptions = () => {
        return [
            { attributes: { optionKey: "primary-color", value: primaryColor } },
            { attributes: { optionKey: "secondary-color", value: primaryColor } },
            { attributes: { optionKey: "group-title-background-color", value: primaryColor } },
            { attributes: { optionKey: "button-color", value: buttonColor } },
            { attributes: { optionKey: "banner-color", value: primaryColor } },
            { attributes: { optionKey: "background-color", value: backgroundColor } },
            { attributes: { optionKey: "font", value: font } },
        ]
    }

    const handleImageChange = (images) => {
        if (images.length > 0) {
            setImages(images)
            setLogo(images[0])
            setLogoId(images[0].id)
        } else {
            setImages([])
            setLogo(null)
            setLogoId("")
        }
    }

    const getCountry = () => {
        const countries = GlobalHelper.getCountries(AppContext.getLocale().getLanguageWithoutRegionCode())
        const country = {
            code: "CA",
            name: "Canada"
        }
        for (const code in countries) {
            if (countryCode === code || countryCode === countries[code]) {
                country.code = code
                country.name = countries[code]
                break
            }
        }
        return country
    }

    const getState = () => {
        const province = {
            code: stateCode || "",
            name: ""
        }
        const prov = provinces.filter(p => p.short === province.code)[0]
        if (prov) {
            province.code = prov.short
            province.name = prov.name
        }
        return province
    }

    return (
        <div className="row py-0 justify-content-center pb-5">

            {state.modal}
            {state.redirect}
            <div className={"col-12 mb-3"}>
                <div className="row py-0 justify-content-center">
                    <div className="col-lg-6 col-md-8 col-12">
                        <h1 className="text-center custom-lead text-custom-primary mb-1">
                            <FormattedMessage
                                id="welcome.thank_you"
                                defaultMessage="Thank you for signing up!"
                            />
                        </h1>
                        <p className="text-center">
                            <FormattedMessage
                                id="welcome.greetings_and_setup"
                                defaultMessage="We are thrilled to have you on board. Let's quickly setup your account!"
                            />
                        </p>
                    </div>
                </div>
            </div>
            <div className="col-lg-4 col-12">
                <dl className="row pr-lg-4">
                    <dt className="col-12 d-flex align-items-center mb-0 custom-form-label">
                        <FormattedMessage
                            id="welcome.company_name_label"
                            defaultMessage="Company name"
                        />
                    </dt>
                    <dd className="col-12 mb-3">
                        <input
                            id={"companyName"}
                            name={"companyName"}
                            value={state.companyName}
                            onChange={handleFormChange}
                            type="text"
                            className="form-control"
                        />
                    </dd>
                    <dt className="col-12 d-flex align-items-center  mb-0 custom-form-label">
                        <FormattedMessage
                            id="welcome.industry_label"
                            defaultMessage="Industry"
                        />
                    </dt>
                    <dd className="col-12 mb-3">
                        <select className={"form-control"} name={"industry"} value={state.industry}
                            onChange={handleFormChange}>
                            <option
                                value={"default"}>{props.intl.formatMessage(messages["choose_industry"])}</option>
                            {state.industries.sort((a, b) => {
                                const nameA = AppContext.getLocale().getLanguageWithoutRegionCode() === "fr" ?
                                    // @ts-ignore todo fix
                                    a.attributes.frenchName : a.attributes.englishName
                                const nameB = AppContext.getLocale().getLanguageWithoutRegionCode() === "fr" ?
                                    // @ts-ignore todo fix
                                    b.attributes.frenchName : b.attributes.englishName
                                let comparison = 0
                                if (nameA > nameB) {
                                    comparison = 1
                                } else if (nameA < nameB) {
                                    comparison = -1
                                }
                                return comparison
                            }).map(i => {
                                // @ts-ignore todo fix
                                return <option value={i.attributes.industryKey} key={i.attributes.industryKey}>
                                    {
                                        AppContext.getLocale().getLanguageWithoutRegionCode() === "fr" ?
                                            // @ts-ignore todo fix
                                            i.attributes.frenchName : i.attributes.englishName
                                    }
                                </option>
                            })}
                        </select>
                    </dd>
                    <dt className="col-12 d-flex align-items-center  mb-0 custom-form-label">
                        <FormattedMessage
                            id="welcome.currency_label"
                            defaultMessage="Currency"
                        />
                    </dt>
                    <dd className="col-12 mb-3">
                        <select className={"form-control"} value={state.currency} onChange={e => {
                            setState({
                                ...state,
                                currency: e.target.value,
                            })
                        }}>
                            {GlobalHelper.getSupportedCurrenciesSelectOptions()}
                        </select>
                    </dd>
                    <dt className="col-12 d-flex align-items-center mb-0 custom-form-label">
                        <FormattedMessage
                            id="welcome.country_label"
                            defaultMessage="Country"
                        />
                    </dt>
                    <dd className="col-12 mb-3" style={{ zIndex: 1002 }}>
                        <CountrySelect countryCode={countryCode} onChange={(_, val) => {
                            setCountryCode(val)
                        }} />
                    </dd>
                    <dt className="col-12 d-flex align-items-center mb-0 custom-form-label">
                        <FormattedMessage
                            id="welcome.state_label"
                            defaultMessage="State"
                        />
                    </dt>
                    <dd className="col-12 mb-3" style={{ zIndex: 1001 }}>
                        <StateSelect countryCode={countryCode} value={stateCode}
                            onChange={(_, val) => {
                                setStateCode(val)
                            }} />
                    </dd>
                    <dt className="col-12 flex-row mb-3 custom-form-label">
                        <FormattedMessage
                            id="welcome.is_tax_inclusive"
                            defaultMessage="Tax Inclusive"
                        />
                        <Checkbox
                            className={"p-2"}
                            id={"isTaxInclusive"}
                            checked={state.isTaxInclusive}
                            onChange={(isChecked) => {
                                setState({
                                    ...state,
                                    isTaxInclusive: isChecked,
                                })
                            }} />
                    </dt>
                    <dt className="col-12 d-flex align-items-center mb-0 custom-form-label">
                        <FormattedMessage
                            id="welcome.colors_label"
                            defaultMessage="Your colors"
                        />
                    </dt>
                    <dd className="col-12 d-flex" style={{ zIndex: 1000 }}>
                        <ColorPicker
                            className={"mr-2"}
                            value={primaryColor}
                            onChange={c => {
                                setPrimaryColor(c)
                            }}
                        />
                        <ColorPicker
                            className={"mr-2"}
                            value={buttonColor}
                            onChange={c => {
                                setButtonColor(c)
                            }}
                        />
                        <ColorPicker
                            value={backgroundColor}
                            onChange={c => {
                                setBackgroundColor(c)
                            }}
                        />
                    </dd>
                    <dt className="col-12 d-flex align-items-start  mb-0 custom-form-label">
                        <FormattedMessage
                            id="welcome.logo_label"
                            defaultMessage="Your logo"
                        />
                    </dt>
                    <dd className="col-12 mb-3">
                        <ImageUploaderDropZone
                            onUpdateImageList={handleImageChange}
                            maxFiles={1}
                            images={images}
                        />
                    </dd>
                </dl>
            </div>
            <div className="col-lg-5 col-12">
                <ProposalColorPreview
                    small={true}
                    options={getOptions()}
                    companyName={state.companyName}
                    companyLogo={logo}
                    title={props.intl.formatMessage(messages["quote_and_invoice_look_and_feel"])}
                />
            </div>
            <div className="col-12 py-3">
                <div className="row justify-content-center">
                    <ActionButton
                        className={"col-lg-3 col-4 btn btn-lg btn-primary d-flex justify-content-center align-items-center"}
                        onClick={() => {
                            submit(props)
                        }}
                        isLoading={isLoading}
                    >
                        <FormattedMessage
                            id="welcome.next_setup"
                            defaultMessage="Save"
                        />
                        <Icon value={"chevron-circle-right"} className={"ml-2"} />
                    </ActionButton>
                </div>
                {
                    isLoading &&
                    <div className="row justify-content-center mt-2 text-primary">
                        <FormattedMessage
                            id="welcome.submit.wait"
                            defaultMessage="Please wait a few moments..."
                        />
                    </div>
                }
            </div>
        </div>
    )
}

export default injectIntl(InitialSetup)


// WEBPACK FOOTER //
// ./src/onboarding/sections/InitialSetup.tsx